module.exports = __webpack_public_path__ + "static/media/json.f96d623d.svg";